import { render, staticRenderFns } from "./SettingManager.vue?vue&type=template&id=9b271230&scoped=true"
import script from "./SettingManager.vue?vue&type=script&lang=js"
export * from "./SettingManager.vue?vue&type=script&lang=js"
import style0 from "./SettingManager.vue?vue&type=style&index=0&id=9b271230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.6_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._v3ikegxpyohwicxz2xngozg43i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b271230",
  null
  
)

export default component.exports